/**
 * Имя BroadcastChannel для оповещения других вкладок о разлогине.
 * Страница frontchannel-logout публикует сообщение, живые вкладки его принимают.
 */
export const LOGOUT_CHANNEL = 'sportexam-frontchannel-logout';

export const LOGOUT_MESSAGE_TYPE = 'logout';
